import React from 'react'
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom'
import Home from './pages/Home'
import Policy from './pages/Policy'
import Header from './components/Header'
import './firebase'
import './index.css'

const App = () => {
  return (
    <Router>
      <Header />
      <Routes>
        <Route exact path="/" element={<Home />} />
        <Route exact path="/home" element={<Home />} />
        <Route exact path="/policy" element={<Policy />} />
      </Routes>
    </Router>
  )
}

export default App
